import { render, staticRenderFns } from "./mian-footer.vue?vue&type=template&id=6fcfa507&scoped=true"
import script from "./mian-footer.vue?vue&type=script&lang=js"
export * from "./mian-footer.vue?vue&type=script&lang=js"
import style0 from "./mian-footer.vue?vue&type=style&index=0&id=6fcfa507&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcfa507",
  null
  
)

export default component.exports